import { render, staticRenderFns } from "./assigned.vue?vue&type=template&id=45b49ea8&scoped=true"
import script from "./assigned.vue?vue&type=script&lang=js"
export * from "./assigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b49ea8",
  null
  
)

export default component.exports